var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Dashboard"},[_c('div',[_c('LastMeasure')],1),_c('div',[_c('Chart')],1),_c('div',[_c('Table')],1),_c('div',[_c('MinMax')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }